import { Skeleton, SkeletonProps } from '@progress/kendo-react-indicators'
interface IProps extends SkeletonProps {

}
const FormSkeleton = ({ ...otherProps }: IProps) => {
    return (
        <Skeleton
            shape='rectangle'
            className='mt-2'
            style={{ width: '100%', height: '62px' }}
            animation={{ type: 'pulse' }}
            {...otherProps}
        />
    )
}

export default FormSkeleton